import {
  AddToBagLoading,
  AddToBagNavigationHeader,
  AddToBagUnavailableIngredients,
} from './components';

export const AddToBag = {
  NavigationHeader: AddToBagNavigationHeader,
  Loading: AddToBagLoading,
  UnavailableIngredients: AddToBagUnavailableIngredients,
};
